import React from "react";
import { Card, Progress, Tag, Button, Alert, Statistic, Row, Col } from "antd";
import { CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";

const PayrollProgress = ({ taskData, onCancel }) => {
  const { status, progress, current_employee, total_employees, error_message, result } = taskData || {};

  const getStatusTag = () => {
    const statusConfig = {
      PENDING: { color: "default", text: "Pending" },
      PROCESSING: { color: "processing", text: "Processing" },
      COMPLETED: { color: "success", text: "Completed" },
      FAILED: { color: "error", text: "Failed" },
      CANCELLED: { color: "warning", text: "Cancelled" },
    };

    const config = statusConfig[status] || statusConfig.PENDING;
    return <Tag color={config.color}>{config.text}</Tag>;
  };

  const getProgressPercent = () => {
    if (status === "COMPLETED") return 100;
    if (status === "FAILED" || status === "CANCELLED") return 0;
    return progress || 0;
  };

  const getProgressStatus = () => {
    if (status === "COMPLETED") return "success";
    if (status === "FAILED" || status === "CANCELLED") return "exception";
    return "active";
  };

  return (
    <Card
      title={
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span>Payroll Processing Status</span>
          {getStatusTag()}
        </div>
      }
      extra={
        status === "PROCESSING" && (
          <Button
            danger
            icon={<CloseCircleOutlined />}
            onClick={onCancel}
          >
            Cancel
          </Button>
        )
      }
    >
      {error_message && (
        <Alert
          message="Error"
          description={error_message}
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}

      {status === "COMPLETED" && (
        <Alert
          message="Success"
          description="Payroll processing completed successfully!"
          type="success"
          showIcon
          icon={<CheckCircleOutlined />}
          style={{ marginBottom: 16 }}
        />
      )}

      <div style={{ marginBottom: 16 }}>
        <Progress
          percent={getProgressPercent()}
          status={getProgressStatus()}
          strokeColor={{
            '0%': '#108ee9',
            '100%': '#87d068',
          }}
        />
      </div>

      {(status === "PROCESSING" || status === "COMPLETED") && total_employees > 0 && (
        <Row gutter={16} style={{ marginBottom: 16 }}>
          <Col span={12}>
            <Statistic
              title="Total Employees"
              value={total_employees}
            />
          </Col>
          <Col span={12}>
            <Statistic
              title="Processed"
              value={current_employee || 0}
              suffix={`/ ${total_employees}`}
            />
          </Col>
        </Row>
      )}

      {status === "COMPLETED" && result && (
        <Row gutter={16}>
          <Col span={8}>
            <Card size="small">
              <Statistic
                title="Success"
                value={result.success_count || 0}
                valueStyle={{ color: '#3f8600' }}
              />
            </Card>
          </Col>
          <Col span={8}>
            <Card size="small">
              <Statistic
                title="Failed"
                value={result.failure_count || 0}
                valueStyle={{ color: result.failure_count > 0 ? '#cf1322' : undefined }}
              />
            </Card>
          </Col>
          <Col span={8}>
            <Card size="small">
              <Statistic
                title="Total"
                value={(result.success_count || 0) + (result.failure_count || 0)}
              />
            </Card>
          </Col>
        </Row>
      )}
    </Card>
  );
};

export default PayrollProgress;
